

















































































































import {
  defineComponent, reactive, ref, Ref, watch, computed,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import {
  createWithdraw,
  getSubJobs,
  searchSubJob,
} from '@/api/index';

import withdrawCreateTableOption from '@/table/Withdraw/withdraw-create';
import withdrawCreateTableOptionDeposit from '@/table/Withdraw/withdraw-create-deposit';
import withdrawCreateWithAmountTableOption from '@/table/Withdraw/withdraw-create-with-amount';
import withdrawCreateDepositWithAmountTableOption from '@/table/Withdraw/withdraw-create-deposit-with-amount';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const PanelWithMaterialPurchaseRequestEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const successModal = ref(null);
    const step = ref(1);
    const refetchQuery = ref(false);
    const forceRender = ref(false);
    const confirmModal = ref(null);
    const subJobTableData = ref({ total: 0, data: [] });

    // Use to find bom item where has bom id
    const filter = computed(() => ({
      filterBomId: route.value.params.bomId,
    }));

    // Use to create purchase request, edit will implement later.
    const form = reactive({
      bomId: route.value.params.bomId,
      userId: -1,
      type: 'WITHDRAW',
      remarks: '',
      status: 'PENDING',
      items: [],
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          await createWithdraw(computedWithdrawInput.value);
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ใบเบิก' });
      },
      state: {
        value: 'READY',
      },
    });
    const selectedBrokenItem: Ref<number[]> = ref([]);
    function selectBrokenItem(id: number) {
      const hitIndex = selectedBrokenItem.value.indexOf(id);
      if (selectedBrokenItem.value.indexOf(id) > -1) selectedBrokenItem.value.splice(hitIndex, 1);
      else selectedBrokenItem.value.push(id);
      if (selectedBrokenItem.value.length !== subJobTableData.value.total) searchValue.value = selectedBrokenItem.value;
      else searchValue.value = 'ALL';
    }

    const computedWithdrawInput = computed(() => ({
      bomId: form.bomId,
      remarks: form.remarks,
      status: form.status,
      type: route.value.name === 'DepositCreateWithBomId' ? 'RETURN' : 'WITHDRAW',
      items: form.items.map((item: any, index) => ({
        materialId: item.material.id,
        bomItemId: item.id,
        amount: item.amount,
        unit: item.unit,
        broken: selectedBrokenItem.value.includes(item.id),
      })).filter((item: any) => item.amount > 0),
    }));
    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== subJobTableData.value.total) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = subJobTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Watch when route change;
    watch(() => route.value.params.bomId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        step.value = 1;
        clearSelect();
        refetchQuery.value = true;
      }
    });
    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receiveSubJobData(data: any) {
      subJobTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 8;
    const createPurchaseRequestPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form.items.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
      totalPages: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
    }));
    async function forward() {
      const result = await searchSubJob({ ids: searchValue.value, bomId: form.bomId });
      form.items = result.map((item: any) => {
        let amount = '0';
        if (route.value.name === 'DepositCreateWithBomId') amount = parseFloat(item.withdrawn_amount - item.amount >= 0 ? `${item.withdrawn_amount - item.amount}` : '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        else amount = parseFloat(item.amount - item.withdrawn_amount >= 0 ? `${item.amount - item.withdrawn_amount}` : '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        return {
          ...item,
          neededAmount: item.amount,
          amount,
        };
      });
      step.value = 2;
    }
    async function backward() {
      step.value = 1;
    }
    const displayRow = computed(() => {
      if (form.items.length < createPurchaseRequestPaginator.value.to) return form.items.slice(createPurchaseRequestPaginator.value.from, form.items.length);
      return form.items.slice(createPurchaseRequestPaginator.value.from, createPurchaseRequestPaginator.value.to);
    });

    // Watch "instantSearch" if redirect from PanelWithMaterialTable component
    watch(() => route.value.query.instantSearch, async (newVal) => {
      if (newVal.length > 0) {
        if (typeof route.value.query.instanceSearch === 'string' && newVal !== 'ALL') {
          selectedItemId.value = [newVal];
          searchValue.value = newVal;
        } else {
          selectedItemId.value = newVal;
          searchValue.value = newVal;
        }
        await forward();
      }
    });

    return {
      successModal,

      forceRender,
      confirmModal,
      step,
      forward,
      backward,

      filter,
      getSubJobs,
      refetchQuery,
      withdrawCreateTableOption,
      selectItem,
      selectedItemId,
      searchValue,
      selectBrokenItem,
      clearSelect,
      selectAll,
      form,

      displayRow,
      page,
      pagination: createPurchaseRequestPaginator,
      withdrawCreateWithAmountTableOption,
      withdrawCreateTableOptionDeposit,
      withdrawCreateDepositWithAmountTableOption,
      subJobTableData,
      receiveSubJobData,

      computedWithdrawInput,
    };
  },
});

export default PanelWithMaterialPurchaseRequestEditor;
